module.exports = __webpack_public_path__ + "fransa mutfak 1.jpg?d525e7c33eb8d69b8edb1e6d5e4d5f9c";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fransa mutfak 1.jpg
// module id = 333
// module chunks = 0